import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback, updateUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        const result = await handleGoogleCallback(sessionId);
        
        if (result.success) {
          // Check if user intended to be a seller
          const authIntent = localStorage.getItem('auth_intent');
          localStorage.removeItem('auth_intent');
          
          if (authIntent === 'seller') {
            // Update user role to seller if they came from seller login
            try {
              await axios.post(
                `${API_URL}/api/users/me/role`,
                { role: 'seller' },
                
              );
              updateUser({ role: 'seller' });
              navigate('/seller', { replace: true });
            } catch (error) {
              console.error('Failed to update role:', error);
              navigate('/seller', { replace: true });
            }
          } else {
            // No explicit intent: if the returning user is already a seller/both,
            // route them to Host Portal; otherwise default to buyer home.
            const returningRole = result?.user?.role;
            if (returningRole === 'seller' || returningRole === 'both') {
              navigate('/seller', { replace: true });
            } else if (returningRole === 'admin' || returningRole === 'subadmin') {
              navigate('/admin', { replace: true });
            } else {
              navigate('/buyer', { replace: true });
            }
          }
        } else {
          navigate('/buyer/login', { state: { error: result.error } });
        }
      } else {
        navigate('/buyer/login', { state: { error: 'Invalid authentication response' } });
      }
    };

    processCallback();
  }, [location.hash, handleGoogleCallback, navigate, updateUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600 font-medium">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
